const ROW_A = ["Meta Advertising", "Premium Websites", "Brand Scaling", "Conversion First"];
const ROW_B = ["Facebook Ads", "Instagram Ads", "Landing Pages", "Creative Direction", "SEO-Ready Builds"];

function RowA({ hidden }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ROW_A.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 font-display text-4xl font-light italic sm:text-6xl ${
              i % 2 === 0 ? "text-white/90" : "marquee-outline"
            }`}
          >
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-[#D4AF37]/80" />
        </span>
      ))}
    </div>
  );
}

function RowB({ hidden }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ROW_B.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-mono text-[11px] uppercase tracking-[0.3em] text-neutral-500">
            {item}
          </span>
          <span className="h-1 w-1 rounded-full bg-[#D4AF37]/60" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/[0.06] bg-[#0A0A0C] py-10 sm:py-14"
    >
      <div data-testid="marquee-track" className="marquee-track flex w-max">
        <RowA hidden={false} />
        <RowA hidden={true} />
      </div>
      <div className="mt-6 border-t border-white/[0.05] pt-5">
        <div data-testid="marquee-track-rev" className="marquee-track-rev flex w-max">
          <RowB hidden={false} />
          <RowB hidden={true} />
        </div>
      </div>
    </section>
  );
}